import gql from 'graphql-tag';
import { useQuery, provideApolloClient } from '@vue/apollo-composable';
import { watch } from 'vue';
import useAlerts from './useAlerts';
import apolloClient from './useApolloClient';

const { addAlert } = useAlerts();

const GET_COMPANY = gql`
  query CompanyQuery($companyId: ID!) {
    company(id: $companyId) {
      NAME
      CMSID
      WEBADDRESS
      CCB
      CATEGORY
      INSIDESALES
      OUTSIDESALES
      CUSTOMERDETAILS
      VENDORDEPT
      VENDORDETAILS
      CERTIFIEDCONTRACTOR
      PRICINGLEVELID
      ARCHITECTDETAILS
      address {
        LINE1
        LINE2
        CITY
        STATE
        POSTALCODE
        COUNTRYNAME
      }
      contacts {
        CONTACTID
        FIRSTNAME
        LASTNAME
        INACTIVE
        email {
          ADDRESS
        }
        phones {
          NUMBERDISPLAY
          TYPEID
        }
      }
      phones {
        NUMBERDISPLAY
        TYPEID
      }
    }
  }
`;

export default function useCompanyQuery() {
  return function (companyId) {
    provideApolloClient(apolloClient);

    const { result, loading, error, refetch } = useQuery(GET_COMPANY, { companyId }, { fetchPolicy: 'no-cache' });

    watch(error, () => {
      if (error.value) {
        console.error('Error fetching company:', error.value);
        addAlert('Error fetching company', 'high', 5);
      }
    });

    return {
      result,
      loading,
      error,
      refetch,
    };
  };
}
